import { ChakraFlex, ChakraText } from '@equip.health/ui';

import MaudMark from './MaudMark';

interface MaiChatHeaderProps {
  patientFirstName: string;
  patientLastName: string;
}

const MaiChatHeader = ({
  patientFirstName,
  patientLastName,
}: MaiChatHeaderProps) => {
  return (
    <ChakraFlex
      data-testid="mai-chat-header"
      alignItems="center"
      borderBottom="1px solid"
      borderColor="neutral.line"
      gap="10px"
      padding="14px 18px"
      flexShrink={0}
    >
      <MaudMark size={32} />
      <ChakraFlex direction="column" gap="2px" minWidth={0}>
        <ChakraText
          data-testid="mai-chat-header__title"
          color="neutral.primary"
          fontSize="16px"
          fontWeight="500"
          lineHeight="1.2"
        >
          Maud AI
        </ChakraText>
        <ChakraText
          data-testid="mai-chat-header__subtitle"
          color="neutral.secondary"
          fontSize="11px"
          lineHeight="1.2"
          noOfLines={1}
        >
          Briefing on {patientFirstName} {patientLastName} · live
        </ChakraText>
      </ChakraFlex>
    </ChakraFlex>
  );
};

export default MaiChatHeader;
